// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___3mPD2","column":"styles__column___1mJKf","rotate":"styles__rotate___gbR67","fadein":"styles__fadein___1f6qy","slideFromRight":"styles__slideFromRight___2k6R9","waves":"styles__waves___3VuKP"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/AnimatedFlex/styles.scss
// module id = ./resources/assets/js/components/AnimatedFlex/styles.scss
// module chunks = 0